// extracted by mini-css-extract-plugin
module.exports = {"root":"Popup_root__oYc57"};